import RentFlowsIndex from '../laisTenantsRentFlows/pages/RentFlowsIndex.vue';
import { laisPath } from '../laisRouteHelpers';

export const ongoingNegotiationRoute = {
  path: laisPath('em-negociacao'),
  component: RentFlowsIndex,
};

export default ongoingNegotiationRoute;
